import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "./eventTypes";

export default function reducer(state = initialState.document.scoringHistoryData, action) {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_SCORING_HISTORY_STARTED: {
      return {
        ...state,
        [action.id]: {
          scoringSessionsHistory: [],
          loaded: false,
          loading: true
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCORING_HISTORY_SESSION_SUCCESS: {
      if (action.payload.result === 0)
        return {
          ...state
        };

      return {
        ...state,
        [action.id]: {
          scoringSessionsHistory: action.payload.result,
          loaded: true,
          loading: false
        }
      };
    }

    case eventTypes.DOCUMENT_SCORING_HISTORY_INVALIDATED: {
      return initialState.document.scoringHistoryData;
    }

    default:
      return state;
  }
}
